import React, { FC } from 'react'
import ArtworkDescriptionConnector, {
  ConnectorProps as ArtworkDescriptionProps,
} from '../../../connectors/ArtworkDescription'
import {
  DELIVERY_TIME_COPY,
  RETURN_POLICY_LINK,
  OPEN_EDITION,
  BOX_TEXT,
  ROLLED_IN_TUBE_TEXT,
  ACRYLIC,
  ACRYLIC_DELIVERY_TIME_COPY,
  METAL,
  METAL_DELIVERY_TIME_COPY,
} from '../../../helpers/constants'
import styles from '../ArtworkDescription.module.scss'
import InfoTitleValue from '../components/InfoTitleValue/InfoTitleValue'

type PrintShippingAndReturnsProps = ArtworkDescriptionProps

const PrintShippingAndReturns: FC<PrintShippingAndReturnsProps> = (props) => {
  const { currentTab, selectedPrintProduct, selectedFrameOption } = props
  const { material } = selectedPrintProduct

  const getPackagingType = () => {
    const isFrameSelected = selectedFrameOption !== null
    const isPaperPrint = material === 'Fine Art Paper' || material === 'Photo Paper'
    const isRolledInATube = isPaperPrint && !isFrameSelected

    return isRolledInATube ? ROLLED_IN_TUBE_TEXT : BOX_TEXT
  }

  const getDeliveryTime = (): string => {
    switch (material) {
      case ACRYLIC:
        return ACRYLIC_DELIVERY_TIME_COPY

      case METAL:
        return METAL_DELIVERY_TIME_COPY

      default:
        return DELIVERY_TIME_COPY
    }
  }

  if (currentTab !== OPEN_EDITION) {
    return null
  }

  return (
    <div className={styles.artworkInfoWrapper}>
      <div className={styles.artworkInfoContainer}>
        <InfoTitleValue title='Delivery Cost:' value='Calculated at checkout.' />
        <InfoTitleValue title='Delivery Time:' value={getDeliveryTime()} />
        {material && (
          <InfoTitleValue
            title='Returns:'
            value={
              <p className='defaultTypographyMedium'>
                {`All Open Edition prints are final sale items and ineligible for returns. Visit our `}
                <a
                  className={styles.artworkInfoLink}
                  target='_blank'
                  rel='noopener noreferrer'
                  href={RETURN_POLICY_LINK}
                  title='help section'
                >
                  help section
                </a>
                {` for more information.`}
              </p>
            }
          />
        )}
        {material && (
          <InfoTitleValue
            title='Handling:'
            value={`${getPackagingType()} Art prints are packaged and shipped by our printing partner.`}
          />
        )}
        <InfoTitleValue title='Ships From:' value='Printing facility in California.' />
      </div>
    </div>
  )
}

export default ArtworkDescriptionConnector(PrintShippingAndReturns)
